import React, { useEffect } from 'react'
import { Col, Row } from "reactstrap";
import { connect } from "react-redux";


// components
import FbChildPathList from "./_list";
import FbChildPathForm from "./_form";
import { showLoader } from "../../../components/loader/loader";
import { ModalFormContainer } from "../../../components/confirmAlert/ModalFormContainer";

// actions
import { clearState, setApp, setCategory, setLoading, setUdn, setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { setForm } from "../../../redux/actions/generalActions/formActions";
import { ButtonNew } from "../../../components/buttons/buttonsActions";

const FbChildPath = props => {
    const { loading } = props.mainProps


    // limpia el state
    useEffect(() => {
        return () => {
            props.clearState();
        }
    }, []);


    const createItem = () => {
        props.setForm()
        ModalFormContainer(FbChildPathForm, {data : null, Form: FbChildPathForm})
    }


    return <>
        { loading && showLoader() }

        <Row>
            <Col md="12">
                <div className="d-flex align-items-center">
                    <div className="ml-auto paddingAdd">
                        <ButtonNew onClick={createItem} />
                    </div>
                </div>
            </Col>
            <Col>
                <FbChildPathList />
            </Col>
        </Row>
    </>
}


const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setForm,
    setApp,
    setCategory,
    setViewMode,
    setLoading
});

export default connect(mapStateToProps, mapActionsToProps)(FbChildPath)